import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { tap, finalize } from 'rxjs/operators';
import { AuthenticationService } from '../core/authentication/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private env = environment;

  constructor(
    private auth: AuthenticationService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let authReq = null;
    let isExternal = false;
    let response: any;

    Object.values(this.env).forEach(item => {
      if ((((item as any).link && req.url.includes((item as any).link)) || ((item as any).localhost && req.url.includes((item as any).localhost))) && (item as any).external) {
        isExternal = true;
      }
    });

    if (isExternal) {
      authReq = req.clone();
    } else {
      authReq = req.clone({
        headers: req.headers
          .set('Content-Type', 'application/json')
          .set('Authorization', this.auth.getToken())
      });
    }

    // send cloned request with header to the next handler.
    return next.handle(authReq)
      .pipe(
        tap(
          // Succeeds when there is a response; ignore other events
          event => response = event,
          // Operation failed; error is an HttpErrorResponse
          error => response = error
        ),
        finalize(() => {
          if (response instanceof HttpResponse && response.headers.get('SetToUpdateIdentity')) {
            // Recarrega o menu da aplicação
            this.auth.reloadMenu();
          }
        })
      );
  }
}
